
import type Sort from '~/type/Sort';
interface Props {
  placeholder: string;
  width: string;
  fontSize: string;
  list: Sort[];
  value: Sort;
}
const __sfc_main = {};
__sfc_main.props = {
  placeholder: {
    key: "placeholder",
    required: false,
    type: String,
    default: 'Сортировать по'
  },
  width: {
    key: "width",
    required: false,
    type: String,
    default: '116px'
  },
  fontSize: {
    key: "fontSize",
    required: false,
    type: String,
    default: '14px'
  },
  list: {
    key: "list",
    required: true,
    type: Array
  },
  value: {
    key: "value",
    required: true,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  function onSelect(e: Event) {
    const val = (e.target as HTMLSelectElement);
    const el = props.list.find(el => el.value === val.value);
    /**
    * Срабатывает при выборе/изменении сортировки
    */
    if (el) emit('change', el);
  }
  return {
    onSelect
  };
};
export default __sfc_main;
